import { ReportState } from '@user-center/enums/reports';

export const FIELD_COMMON_ERR_MSG = 'this field is required';

/**
 * Cascader「全部」权限对应的特殊 value（配合 all 配置使用）
 */
export const PERMISSION_ALL_VALUE = '__permission_all__';

/**
 * 表单中表示「全部权限」的级联选中值
 */
export const PERMISSION_ALL_PATH: string[][] = [[PERMISSION_ALL_VALUE]];

/**
 * Game Research Report 一级分类的 value
 */
export const GAME_RESEARCH_CATEGORY_VALUE = 'gameResearch';

export const LOCATION_OPTIONS = [
  // {
  //   text: 'Market Reports',
  //   textCN: '市场报告',
  //   value: 'intelligence',
  //   children: [
  //     { text: 'DataBrain', textCN: 'DataBrain', value: 'DataBrain' },
  //     { text: 'Sensor Tower', textCN: 'Sensor Tower', value: 'Sensor Tower' },
  //     { text: 'Other Vendors', textCN: 'Other Vendors', value: 'Ampere' },
  //     { text: 'VGI', textCN: 'VGI', value: 'VGI' },
  //     { text: 'Stream Hatchet', textCN: 'Stream Hatchet', value: 'Stream Hatchet' },
  //     { text: 'Fandom', textCN: 'Fandom', value: 'Fandom' },
  //     { text: 'Others', textCN: 'Others', value: 'Others' },
  //   ],
  // },
  {
    text: 'Insights Reports',
    textCN: '洞察报告',
    value: 'intelligence_insights',
    children: [
      { text: 'Market', textCN: '市场', value: 'Market' },
      { text: 'Game & Genres', textCN: '游戏 & 品类', value: 'Game & Genres' },
      { text: 'Players', textCN: '玩家', value: 'Players' },
      { text: 'Monetization', textCN: '商业化', value: 'Monetization' },
      { text: 'Compliance', textCN: '合规', value: 'Compliance' },
    ],
  },
  {
    text: 'AI Hub Reports',
    textCN: 'AI专区报告',
    value: 'intelligence_ai',
    children: [
      { text: 'Game AI', textCN: '游戏AI', value: 'Game AI' },
      { text: 'AI Assets', textCN: 'AI素材', value: 'AI Assets' },
    ],
  },
  {
    text: 'Insights Center Reports',
    textCN: 'IIC中心报告',
    value: 'intelligence_iic',
    children: [
      { text: 'Fundamental Study', textCN: '基础研究', value: 'Fundamental Study' },
      {
        text: 'GRIP Report',
        textCN: 'GRIP报告',
        value: 'GRIP Report',
        children: [
          { text: 'Competitor Analysis', textCN: '竞品分析', value: 'Competitor Analysis' },
          { text: 'Market Event Recap', textCN: '市场事件回顾', value: 'Market Event Recap' },
        ],
      },
      {
        text: 'Regional Monthly Report',
        textCN: '区域月报',
        value: 'Regional Monthly Report',
        children: [
          { text: 'NA', textCN: '北美', value: 'NA' },
          { text: 'EU', textCN: '西欧', value: 'EU' },
          { text: 'MENA', textCN: '中东', value: 'MENA' },
          { text: 'LATAM', textCN: '拉美', value: 'LATAM' },
        ],
      },
    ],
  },
  {
    text: 'Game Research Report',
    textCN: '游戏研究报告',
    value: GAME_RESEARCH_CATEGORY_VALUE,
    children: [
      { text: '敏捷报告 Agility Report', textCN: '敏捷报告 Agility Report', value: '敏捷报告 Agility Report' },
      { text: 'Company Research', textCN: '商业分析', value: 'Company Research' },
      { text: 'IP Reports', textCN: 'IP报告', value: 'IP Reports' },
    ],
  },
];

export const DEFAULT_FORM_MODEL: IReportFormModel = {
  file: null,
  file_en: null,
  title: '',
  title_en: '',
  introduction: '',
  introduction_en: '',
  tag: '',
  tag_en: '',
  cover: null,
  location: [],
  permission: [[PERMISSION_ALL_VALUE]],
  creator_name_en: '',
  creator_avatar: null,
  creator_department_en: '',
  collaborators: [],
  download_enable: true,
  watermark_enable: true,
};

export const DEFAULT_REPORT: IReport = {
  id: Number.NaN,
  resource_id: '',
  system: '',
  source: '',
  sub_source: '',
  report_type: '',
  report_type_en: '',
  report_language: '',
  report_language_en: '',
  file_cn_language: '',
  file_en_language: '',
  title: '',
  title_en: '',
  introduction: '',
  introduction_en: '',
  tag: '',
  tag_en: '',
  file_name: '',
  file_name_en: '',
  cover: '',
  attachment: '',
  original_file_name: '',
  creator_name: '',
  creator_name_en: '',
  creator_head_picture: '',
  creator_department: '',
  creator_department_en: '',
  permission: [],
  download_enable: 0,
  watermark_enable: 0,
  state: ReportState.UnPublished,
};

export const DEFAULT_REPORT_REQ: IReportReq = {
  id: Number.NaN,
  resource_id: '',
  system: '',
  source: '',
  sub_source: '',
  report_type: '',
  report_type_en: '',
  report_language: '',
  report_language_en: '',
  file_cn_language: '',
  file_en_language: '',
  title: '',
  title_en: '',
  introduction: '',
  introduction_en: '',
  tag: '',
  tag_en: '',
  file_name: '',
  file_name_en: '',
  cover: '',
  attachment: '',
  original_file_name: '',
  creator_name: '',
  creator_name_en: '',
  creator_head_picture: '',
  creator_department: '',
  creator_department_en: '',
  collaborators: [],
  permission: [],
  download_enable: 0,
  wartermark_enable: 0,
  state: ReportState.UnPublished,
};
